interface VinylIconProps {
  isPlaying: boolean;
}

export function VinylIcon({ isPlaying }: VinylIconProps) {
  if (isPlaying) {
    return (
      <svg
        className="vinyl-playing"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g className="vinyl-disc">
          <circle cx="24" cy="24" r="20" fill="#222" stroke="#555" strokeWidth="1" />
          <circle cx="24" cy="24" r="16" fill="none" stroke="#3a3a3a" strokeWidth="0.8" />
          <circle cx="24" cy="24" r="12" fill="none" stroke="#3a3a3a" strokeWidth="0.8" />
          <circle cx="24" cy="24" r="8" fill="none" stroke="#3a3a3a" strokeWidth="0.8" />
          <circle cx="24" cy="24" r="4" fill="#555" />
          <circle cx="24" cy="24" r="1.8" fill="#111" />
        </g>
        <g className="vinyl-tonearm">
          <line
            x1="42"
            y1="6"
            x2="30"
            y2="19"
            stroke="#aaa"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <circle cx="42" cy="6" r="2" fill="#777" />
          <circle cx="30" cy="20" r="1.5" fill="#aaa" />
        </g>
      </svg>
    );
  }

  return (
    <svg
      className="vinyl-idle"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="10" width="28" height="28" fill="#1a1a1a" stroke="#555" strokeWidth="1" />
      <rect x="5" y="13" width="22" height="22" fill="#0d0d0d" stroke="#2a2a2a" strokeWidth="0.5" />
      <clipPath id="cp-idle">
        <rect x="28" y="8" width="20" height="32" />
      </clipPath>
      <g clipPath="url(#cp-idle)">
        <circle cx="32" cy="24" r="13" fill="#1e1e1e" stroke="#555" strokeWidth="1" />
        <circle cx="32" cy="24" r="10" fill="none" stroke="#3a3a3a" strokeWidth="0.6" />
        <circle cx="32" cy="24" r="7" fill="none" stroke="#333" strokeWidth="0.6" />
        <circle cx="32" cy="24" r="4" fill="none" stroke="#2e2e2e" strokeWidth="0.6" />
        <circle cx="32" cy="24" r="2.5" fill="#555" />
        <circle cx="32" cy="24" r="1.1" fill="#111" />
      </g>
    </svg>
  );
}
